import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as planReducer, REDUCER_NAME as PLAN_REDUCER_NAME } from './plan'
import { reducer as processReducer, REDUCER_NAME as PROCESS_REDUCER_NAME } from './quotation'
import { reducer as reassignReducer, REDUCER_NAME as REASSIGN_REDUCER_NAME } from './reassign'

const reducer = combineReducers({
    [PLAN_REDUCER_NAME]: planReducer,
    [PROCESS_REDUCER_NAME]: processReducer,
    [REASSIGN_REDUCER_NAME]: reassignReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/index.js